var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivideLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 43,
    viewBox: "0 0 2 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 43,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agent Portal 2",
    clipPath: "url(#clip0_1359_8201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4200,
    transform: "translate(-1125 -16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 75,
    transform: "translate(-1125 -16)",
    fill: "#0E4574"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 521",
    d: "M1 0C1 0 1 26.2075 1 43",
    stroke: "#D8D8D8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1359_8201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4200,
    fill: "white",
    transform: "translate(-1125 -16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivideLine);
export default __webpack_public_path__ + "static/media/divide-line.68fd1e0a52d8cddf8d02aea58335f0d1.svg";
export { ForwardRef as ReactComponent };